import React, { useState } from 'react'
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md"

interface AccordionProps {
    title: string
    isOpen?: boolean
    children: React.ReactNode
}

const AccordionWithChildren = ({ title, isOpen = false, children }: AccordionProps) => {
    const [open, setOpen] = useState<boolean>(isOpen);

    const handleOpen = () => {
        setOpen(!open)
    };

    return (
        <div className="flex flex-col w-full p-4 bg-transparent">
            <button className='flex justify-between items-center w-full' onClick={handleOpen}>
                <span className={`text-left text-tsmall text-system-light-40`}>
                    {title}
                </span>
                {open ? <MdArrowDropUp /> : <MdArrowDropDown />}
            </button>
            {open && (
                <div className='p-1 transition duration-700 ease-in-out'>
                    {children}
                </div>
            )}
        </div>
    )
}

export default AccordionWithChildren